import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Clock, Snowflake, ShoppingBag, Calendar, Check, X } from 'lucide-react';
export function WhatYouGetSection() {
  const deliverables = [{
    icon: BookOpen,
    title: 'El Manual Digital',
    subtitle: 'Adiós a la Fascitis Plantar',
    desc: 'PDF de lectura rápida y sin relleno. Directo al grano para que empieces a sanar hoy.'
  }, {
    icon: Clock,
    title: 'El Protocolo de 2 Minutos',
    subtitle: "Movimientos 'Cero Pasos'",
    desc: "3 movimientos clave para 'despertar' tus pies antes de levantarte de la cama."
  }, {
    icon: Snowflake,
    title: 'Técnica Rolling-Freeze',
    subtitle: 'Alivio profundo',
    desc: 'Cómo usar terapia de frío y presión casera para desinflamar el arco profundamente.'
  }, {
    icon: ShoppingBag,
    title: 'Guía de Calzado para Trabajadoras',
    subtitle: 'Protege tu inversión',
    desc: 'Qué buscar en tiendas como Amazon, Walmart o Target para cuidar tu salud.'
  }, {
    icon: Calendar,
    title: 'Plan de Acción de 7 Días',
    subtitle: 'Ruta exacta',
    desc: 'Tu mapa paso a paso para volver a caminar sin dolor en una semana.'
  }];
  return <section className="py-24 bg-slate-50" data-id="element-216">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-217">
        <div className="text-center mb-16" data-id="element-218">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-219">
            Todo lo que necesitas para recuperar tus pies
          </h2>
          <p className="text-lg text-slate-600" data-id="element-220">
            Un sistema completo, práctico y diseñado para mujeres ocupadas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-24" data-id="element-221">
          {deliverables.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-soft border border-slate-100 hover:-translate-y-1 transition-transform duration-300" data-id="element-222">
              <div className="w-14 h-14 bg-brand-50 rounded-xl flex items-center justify-center text-brand-600 mb-6" data-id="element-223">
                <item.icon className="w-7 h-7" data-id="element-224" />
              </div>
              <h3 className="font-bold text-xl text-slate-900 mb-1" data-id="element-225">
                {item.title}
              </h3>
              <p className="text-brand-600 font-medium text-sm mb-4" data-id="element-226">
                {item.subtitle}
              </p>
              <p className="text-slate-600 leading-relaxed" data-id="element-227">{item.desc}</p>
            </motion.div>)}
        </div>

        {/* Who is it for / Not for */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-228">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-3xl border-2 border-green-100 shadow-sm" data-id="element-229">
            <h3 className="text-2xl font-display font-bold text-slate-900 mb-6 flex items-center gap-3" data-id="element-230">
              <span className="bg-green-100 text-green-600 p-2 rounded-full" data-id="element-231">
                <Check className="w-6 h-6" data-id="element-232" />
              </span>
              Para quién ES esto
            </h3>
            <ul className="space-y-4" data-id="element-233">
              {['Mujeres que trabajan de pie más de 6 horas al día (Nurses, limpieza, maestras, retail).', "Personas que sienten un 'pinchazo' agudo en el talón al despertar o tras estar sentadas.", 'Quienes ya han gastado en zapatos caros y plantillas sin ver una mejora real.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-234">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-235" />
                  <span className="text-slate-700" data-id="element-236">{text}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-3xl border-2 border-red-50 shadow-sm" data-id="element-237">
            <h3 className="text-2xl font-display font-bold text-slate-900 mb-6 flex items-center gap-3" data-id="element-238">
              <span className="bg-red-50 text-red-500 p-2 rounded-full" data-id="element-239">
                <X className="w-6 h-6" data-id="element-240" />
              </span>
              Para quién NO es
            </h3>
            <ul className="space-y-4" data-id="element-241">
              {['Personas que buscan una solución mágica sin dedicar 2 minutos al día a los ejercicios.', 'Casos de fracturas óseas o condiciones que requieren cirugía mayor.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-242">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-243" />
                  <span className="text-slate-600" data-id="element-244">{text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}